import OrderPackageTable from './OrderPackageTable';

export default OrderPackageTable;
